// extracted by mini-css-extract-plugin
export default {"searchBox":"bx_gM","resultsOpen":"bx_gN"};